import api from '@/apis/di/budgetFeesAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('budgetFees', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_fees',
    field: {
      key: 'budget_fees_id',
      code: 'budget_fees_code',
      name: 'budget_fees_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
